<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {
            loading: null,
            redirect: this.$route.query.redirect || '/manage',
            sskey: this.$route.query.sskey || '',
            key: this.$route.query.key || ''
        }
    },
    created() {
        this.loading = this.$loading({
            lock: true,
            text: '自动登录中...',
            spinner: 'el-icon-loading',
            background: 'rgba(225, 225, 225, 0.9)'
        });
        if (this.sskey) {
            this.showstartAutoLogin();
        } else {
            this.autoLogin();
        }
    },
    methods: {
        //秀动用户跳转登录
        showstartAutoLogin() {
            this.$request({
                url: '/org/showStart/login',
                method: 'GET',
                params: {
                    key: this.sskey,
                    cpLoginType: 2
                }
            })
                .then(res => {
                    const { state, result } = res.data;
                    if (!state) {
                        this.loginFail();
                    } else {
                        this.loginSucc(result)
                    }
                })
                .catch(() => {
                    this.loginFail();
                })
                .finally(() => {
                    this.loading.close();
                });
        },
        //秀动发行管理后台跳转登录
        autoLogin() {
            this.$request({
                url: '/org/autoLogin',
                method: 'POST',
                data: {
                    sign: this.key,
                    cpLoginType: 2
                }
            })
                .then(res => {
                    const { state, result } = res.data;
                    if (!state) {
                        this.loginFail();
                    } else {
                        this.loginSucc(result)
                    }
                })
                .catch(() => {
                    this.loginFail();
                })
                .finally(() => {
                    this.loading.close();
                });
        },
        loginSucc(result) {
            this.$store.commit("SET_USERINFO", result || null);
            this.$router.push(this.redirect);
        },
        loginFail() {
            this.$message.error('登录失败,重新登录');
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.redirect
                }
            });
        }
    }
}
</script>